export default "images/L1a.jpg";